<template>
  <div class="mod-trade__agreement}">
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @selection-change="dataListSelectionChangeHandle"
      style="width: 100%"
      :max-height="maxTableHeight"
    >
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
        label="行号"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="产品名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="size"
        label="尺寸"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr1"
        label="规格"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr2"
        label="其他"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="count"
        label="合同数量"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column label="剩余数量" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.limitCount > 0 ? 'warning' : 'primary'">
            {{ scope.row.limitCount }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="采购单价" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column
        label="小计"
        header-align="center"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.amount * scope.row.count }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  components: {},
  props: {
    parentId: {
      type: String,
      default: "",
    },
    maxTableHeight: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      statusType: {
        10: "",
        20: "warning",
        30: "success",
      },
      mixinViewModuleOptions: {
        getDataListURL: "/trade/purchase/agreement/detail/list",
        getDataListIsPage: false,
        deleteIsBatch: true,
        activatedIsNeed: false,
      },
      dataForm: {
        parentId: "",
      },
    };
  },
  watch: {
    parentId: {
      handler: function (newVal) {
        if (!newVal) {
          this.dataList = [];
          return;
        }
        this.dataForm.parentId = newVal;
        this.getDataList();
      },
      immediate: true,
    },
  },
  methods: {
    beforeTableBinding(dataList) {
      if (!dataList || dataList.length === 0) {
        return;
      }
      dataList.forEach((item) => {
        item.limitCount = item.count - (item.completeCount || 0);
      });
    },
  },
};
</script>
